if(!customElements.get('hero-cta-slider')) {
  customElements.define(
    'hero-cta-slider',
    class HeroCTASlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) {
          return console.error('An error ocurred while trying to initialize Hero Slider. No slider element was found.')
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 24
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40
            }
          },
        });
      }
    }
  );
}
